export default __webpack_public_path__ + "static/media/crm.1934e0db.png";